import { Component, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuditLogSearchModel, AuditLogService } from "../../../audit-log/audit-log";
import { ModalService, LogService, BaseEntityTableComponent } from "../../../core/core";
import { DatePipe } from "@angular/common";

@Component({
  selector: "common-show-entity-history",
  templateUrl: "./show-entity-history.component.html",
})
export class ShowEntityHistoryComponent extends BaseEntityTableComponent {
  @Input() label: string = "History";
  @Input() show: boolean = false;
  @Input() entityId: string;

  searchModel: AuditLogSearchModel;

  columns = [
    { name: "date", prop: "auditMetadata.createdDateTime", pipe: { transform: this.dateTimePipe } },
    { name: "Type", prop: "auditLogType" },
    {
      name: "Changes",
      prop: "changes",
      pipe: {
        transform: (changesString: string) => {
          return this.renderChanges(JSON.parse(changesString));
        },
      },
      customTemplate: "checkMark",
    },
    { name: "User", prop: "userName" },
    { name: "email", prop: "userEmail" },
    { name: "Admin Change", prop: "isAdminChange" },
  ];

  constructor(public auditService: AuditLogService, router: Router, activatedRoute: ActivatedRoute, modalService: ModalService, logService: LogService) {
    super(router, activatedRoute, modalService, logService);
  }

  showNow() {
    this.show = true;
    this.searchModel = new AuditLogSearchModel();
    this.searchModel.referenceObjectId = this.entityId;
    this.searchModel.sortByField = "auditMetadata.createdDateTime";
    this.searchModel.sortAscending = false;
  }

  dateTimePipe(date: string) {
    return date ? new DatePipe("en").transform(date, "short") : "-";
  }

  /** Breaks up `text` with `<br/>` every `max` chars */
  private breakLines(text: string = "", max: number = 200): string {
    let out = "";
    for (let i = 0; i < text.length; i += max) {
      out += text.substr(i, max);
      if (i + max < text.length) out += "<br/>";
    }
    return out;
  }

  /** Recursively renders diffs, wrapping long values */
  renderChanges(changes: any, depth: number = 0): string {
    if (!changes || typeof changes !== "object") return "";

    return Object.entries(changes)
      .map(([field, change]) => {
        const indentPx = depth * 16; // e.g. 16px per level
        const isLeaf = change && typeof change === "object" && Object.keys(change).every(k => k === "+" || k === "-");

        if (isLeaf) {
          const plus = this.breakLines(change["+"]?.toString(), 50);
          const minus = this.breakLines(change["-"]?.toString(), 50);

          return `
            <div class="d-flex flex-wrap" style="margin-left:${indentPx}px; margin-bottom:4px">
              <strong class='d-block'>${field}:</strong>
              <br/>
              <div class="badge badge-success mr-1" [innerHTML]="">${plus}</div>
              <div class="badge badge-danger ms-1" [innerHTML]="">${minus}</div>
            </div>
          `;
        } else {
          // nested object
          return `
            <div class="d-flex flex-wrap" style="margin-left:${indentPx}px; margin-bottom:4px">
              <strong>${field}:</strong>
              <br/>
              ${this.renderChanges(change, depth + 1)}
            </div>
          `;
        }
      })
      .join("");
  }
}
